import React from "react";

import svg from "../../assets/images/icons/Tester/return.svg";

export const ResetIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={svg}
        alt={alt || "Reset"}
    />
);
